import React from 'react'
import { isDevSite } from './utils/general'

export const DOMAIN_EXISTS = 'DOMAIN_EXISTS'
export const INVALID_UPDATE_CODE = 'INVALID_UPDATE_CODE'
export const DOMAIN_SUFFIX = '.tiiny.site'
export const NOT_OWNER = 'NOT_OWNER'
export const NO_INDEX_FILE = 'NO_INDEX_FILE'
export const USER_EXISTS = 'USER_EXISTS'
export const USER_TRIAL_EXPIRED = 'USER_TRIAL_EXPIRED'
export const INVALID_EMAIL = 'INVALID_EMAIL'
const USER_UNVERIFIED = 'USER_UNVERIFIED'
const FLAGGED = 'FLAGGED'

export const TLDS = {
  TIINY_SITE: '.tiiny.site',
  TIINY_CO: '.tiiny.co',
  TIINY_CO_UK: '.tiiny.co.uk'
}

export const DEFAULT_TLDS = Object.values(TLDS)

export const TLD_S3_PATH_CONFIG = {
  [TLDS.TIINY_SITE]: ({ subdomain }) => subdomain,
  [TLDS.TIINY_CO]: ({ subdomain, tld }) => `${subdomain}${tld}`,
  [TLDS.TIINY_CO_UK]: ({ subdomain, tld }) => `${subdomain}${tld}`
}

export const FILE_TYPE = {
  PDF: 'PDF',
  HTML: 'HTML'
}

// Analytics
export const SOURCE_HOMEPAGE = 'SOURCE_HOMEPAGE'
export const SOURCE_LOGIN = 'SOURCE_LOGIN_PAGE'
export const SOURCE_PRICING = 'SOURCE_PRICING_PAGE'
export const SOURCE_LOGGED_IN = 'SOURCE_LOGGED_IN'

export const ERROR_MSGS = {
  [INVALID_EMAIL]: 'Please enter a genuine email address',
  [INVALID_UPDATE_CODE]: 'Invalid update code',
  [NOT_OWNER]: "You don't own this link",
  [NO_INDEX_FILE]: "Your zip doesn't contain an index.html file",
  [DOMAIN_EXISTS]: 'Sorry, that link name is taken',
  [USER_EXISTS]: 'Please login to your account',
  [USER_TRIAL_EXPIRED]: 'Sorry, your trial has expired. Please upgrade.',
  [USER_UNVERIFIED]: "Please verify your account, we've sent you an email",
  [FLAGGED]:
    'We\'re unable to host this type of content <br />on a <b>trial account</b>.<br/><br/><a href="https://tiiny.host/pricing"><b><u>Upgrade your account</u></b></a>'
}

/* eslint-disable */
// prettier-ignore
export const REGEX_FULLDOMAIN = /^([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
// prettier-ignore
export const REGEX_SUBDOMAIN = /^(?!-)[A-Za-z0-9-]*[A-Za-z0-9]-?$/
// prettier-ignore
export const REGEX_DOMAIN = /^[A-Za-z0-9](?:[A-Za-z0-9\\-]{0,61}[A-Za-z0-9])*$/;
// prettier-ignore
export const REGEX_EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// prettier-ignore
export const REGEX_USERNAME = /^[a-zA-Z0-9_]{3,20}$/;
// prettier-ignore
export const REGEX_PASSWORD = /^[^:]+$/;
// prettier-ignore
export const REGEX_ERROR_PATH = /^\/.+$/;

export const DISALLOWED_EMAILS = ['hi2.in', 'mailinator.com']
/* eslint-disable */

export const MAX_FILE_SIZE = 25; // link preview max
export const MAX_PDF_SIZE = 25; // link preview max

export const MAX_FREE_FILE_SIZE = 3;
export const MAX_FREE_PDF_SIZE = 0.5

const getBaseURL = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:8000'
  } else if (isDevSite()) {
    return 'https://api.tiiny.co.uk'
  } else {
    return 'https://api.tiiny.host'
  }
}

export const API_ROOT = getBaseURL()

export const reCAPTCHA_CLIENT = '6LeMIfQUAAAAAGblGGmutcrS1gaG3YMyRPzkG5N7'

const getStripeKey = () => {
  if (isDevSite()) {
    return 'pk_test_51GyQOLKnX1nnNv6ISZ7YCm5nBySiWLHHcFIir2ALdrrARBkHnSwZe2CTbadw9pWLEBbLVncQOAsXh56RK8YNMRsD00QdWbapEb'
  } else {
    return 'pk_live_51GyQOLKnX1nnNv6I5F3a2LwxUfNq7kDmV4oNDqpXk1LGdgaKaiOelZsUt8I7SYqffFSkBeYkyMNU9kWBAo7vFqtx00Rcdt5Fcu'
  }
}

export const STRIPE_KEY = getStripeKey()

export const ARCHIVE_ENDPOINT = 'https://s3-eu-west-1.amazonaws.com/archive.tiiny.host'

export const LIFETIME_PRICE = 79

export const ENTRI_APP_ID = isDevSite() ? 'tiiny.host_dev' : 'tiiny.host'

export const PSPDFKIT_LICENSE_KEY =
  'pz_n0KIKTPh357NVzVJWTIWumbB1vzpjLuPeTiKqwgO0dkhp9zoKG5nGSOwX-62jw_ozYx4lH-lJ6zQt19-ZYLlCqr0JTq2dJnzk-_2QBLUO7oX2Wz3iKJoowasQIUp41EsHI_EH9ahX8B4cOMHxeqPtsfhJVo1h4Q0_IuXbZTlPvfDRRN9-Au70e-eWq6a_ALQGNiugokhG0wyUVy3u2YIFncarqYg9DbRpa-gzLJORjd9aMM8-5mH-x7o_a6qGsjszGcI1ebvCqtKW6d2_C0I0utcf2CT0XPt55jZSz0G-Hz4bc_I6xlEkv0G1SL8g6ll0gF7CV1tW3yBEckhV_EtWiOiVCSzzlivT4SV5_FqM1LXkEWnwre4CZK87x3yjqk0E-0OGnNTUn8ko9ms4EWCPXq7aloObe-t2i1BF6wPNgtJcrkrsdnXc5ttWQQ2WgQ-HoeZPxCCVCjTNeAnW7plyFYvImVGTRwjHz7VZzTQcq-TNfYSZG0apMkINFC1MV1ui3WpGyJOyyvofiT4ZfDHyfE4pxCyFDupq98FyhuCTzoFx0Xe3c0mWv0UA8956'
